import { render, staticRenderFns } from "./ResourcesCrud.vue?vue&type=template&id=3fb70254&scoped=true"
import script from "./ResourcesCrud.vue?vue&type=script&lang=js"
export * from "./ResourcesCrud.vue?vue&type=script&lang=js"
import style0 from "./ResourcesCrud.vue?vue&type=style&index=0&id=3fb70254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb70254",
  null
  
)

export default component.exports